module.exports = __webpack_public_path__ + "static/img/check-green.0b574a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/check-green.png
// module id = isHl
// module chunks = 1